import { controllers } from '../../../controllers/controller';
import { pagination } from '../pagination';
import { isShowElement, isHideElement } from '../elements';
import { Word } from './Word';
var renderTextBook = function (isUserSignIn, group) {
    var lists = document.querySelector('.word__cards');
    lists.setAttribute('data-group', group);
    if (controllers.words.length > 0) {
        controllers.words.forEach(function (word) {
            var statistics = [0, 0];
            var li = new Word(word, isUserSignIn, statistics);
            lists.append(li.show().element);
            li.init();
        });
    }
    else {
        var p = document.createElement('p');
        p.textContent = 'Отсутствуют сложные слова';
        lists.append(p);
    }
};
var updateDictionary = function () {
    var lists = document.querySelector('.dictionary__lists');
    var paginationLists = document.querySelector('.dictionary__pages');
    var containerGroupButtons = document.querySelector('.dictionary__lists');
    var buttonsGroup = containerGroupButtons.querySelectorAll('button');
    if (controllers.isUserSignIn) {
        isShowElement(lists);
        isShowElement(paginationLists);
        if (controllers.wordsGroup === '6') {
            isHideElement(paginationLists);
        }
    }
    else {
        isHideElement(lists);
        isShowElement(paginationLists);
    }
    pagination.init(paginationLists, {
        size: 30,
        page: controllers.wordsPage,
        step: 2, // pages before and after current
    });
    buttonsGroup.forEach(function (button) {
        var group = button.getAttribute('data-group');
        if (button.classList.contains('dictionary__button-active')) {
            button.classList.remove('dictionary__button-active');
        }
        if (group === controllers.wordsGroup &&
            !button.classList.contains('dictionary__button-active')) {
            button.classList.add('dictionary__button-active');
        }
    });
};
export { renderTextBook, updateDictionary };
